'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'sailboat';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M64 416l48 64 352 0 48-64L64 416zm41.1-96l86.9 0 0-142.3L105.1 320zM288 93.7L288 320l174.8 0L288 93.7z', 'M288 352l-32 0 0-32 0-267.7L256 0l32 41.4L503.3 320 528 352l-40.4 0L288 352zm174.8-32L288 93.7 288 320l174.8 0zM40 384l496 0 40 0-24 32-72 96L96 512 24 416 0 384l40 0zm24 32l48 64 352 0 48-64L64 416zm160-64l-32 0L85.5 352 48 352l19.6-32L192 116.4 224 64l0 61.4L224 320l0 32zM192 177.7L105.1 320l86.9 0 0-142.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;